import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { GoogleRecaptchaSettings } from "./app-settings-config-google-recaptcha";

export interface IGoogleRecaptchaInputState {
  showModal: boolean;
  editingRecaptchaId: string;
}

export interface IGoogleRecaptchaInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class GoogleRecaptchaInput extends PureComponent<IGoogleRecaptchaInputProps, IGoogleRecaptchaInputState> {
  formInputName = ["apiConfig", "googleRecaptchaSettingsId"];

  constructor(props: IGoogleRecaptchaInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingRecaptchaId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingRecaptchaId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingRecaptchaId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;
    return (
      <>
        <GoogleRecaptchaSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingRecaptchaId={this.state.editingRecaptchaId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <div style={{ marginTop: 16 }}>
          <ConfigSettingSelect
            label="Configuration"
            formInputName={this.formInputName}
            options={this.props.commonSettings?.googleRecaptchaSettings ?? []}
            allowClear
            tooltipContentKey="appsettings_googlerecaptcha_configuration"
            onAddNew={this.openModal}
            onEdit={this.setEditingSetting}
            parentConfigValue={this.props.parentConfigValue}
            onRestore={this.handleRestore}
            dropdownTestId="appSettingsGoogleRecaptchaDropdown"
            addNewTestId="appSettingsGoogleRecaptchaAddNewButton"
            editTestId="appSettingsGoogleRecaptchaEditButton"
          />
        </div>
      </>
    );
  }
}
